// extracted by mini-css-extract-plugin
export default {"container":"aaQfDO","stripes":"dXrK8g","block":"dHMJ9a","text":"Dsv_Lf"};